import types from './types'

const updatePerson = (updatedPerson) => ({
    type: types.UPDATE_PERSON, updatedPerson
})

const resetPerson = () => ({
    type: types.RESET_PERSON
})

export default {
    updatePerson,
    resetPerson
}